import { moroccoRegions } from "./parties";

export type RegionMapData = {
  id: string;
  name: string;
  nameAr: string;
  num: number;
  color: string;
  x: number; // percentage 0-100
  y: number; // percentage 0-100
  stats: {
    registeredVoters: number;
    participation2021: number;
    seats: number;
  };
  connectedTo: string[]; // IDs of connected regions for the network aesthetic
};

// Simplified geography to build a modern abstract "Node Network" map of Morocco
export const regionsMapData: RegionMapData[] = [
  {
    id: "TTA",
    name: "Tanger-Tétouan-Al Hoceïma",
    nameAr: "طنجة-تطوان-الحسيمة",
    num: 1, color: "#02A89E",
    x: 55, y: 12,
    stats: { registeredVoters: 1850000, participation2021: 52.1, seats: 29 },
    connectedTo: ["RSK", "FM", "ORI"]
  },
  {
    id: "ORI",
    name: "L'Oriental",
    nameAr: "الشرق",
    num: 2, color: "#F26522",
    x: 80, y: 28,
    stats: { registeredVoters: 1420000, participation2021: 48.3, seats: 24 },
    connectedTo: ["TTA", "FM", "DT"]
  },
  {
    id: "FM",
    name: "Fès-Meknès",
    nameAr: "فاس-مكناس",
    num: 3, color: "#00A651",
    x: 60, y: 28,
    stats: { registeredVoters: 2580000, participation2021: 54.0, seats: 37 },
    connectedTo: ["TTA", "ORI", "RSK", "BMK", "DT"]
  },
  {
    id: "RSK",
    name: "Rabat-Salé-Kénitra",
    nameAr: "الرباط-سلا-القنيطرة",
    num: 4, color: "#E30613",
    x: 45, y: 25,
    stats: { registeredVoters: 2890000, participation2021: 51.5, seats: 39 },
    connectedTo: ["TTA", "FM", "CS", "BMK"]
  },
  {
    id: "BMK",
    name: "Béni Mellal-Khénifra",
    nameAr: "بني ملال-خنيفرة",
    num: 5, color: "#0071BC",
    x: 50, y: 40,
    stats: { registeredVoters: 1500000, participation2021: 56.4, seats: 25 },
    connectedTo: ["RSK", "FM", "CS", "MS", "DT"]
  },
  {
    id: "CS",
    name: "Casablanca-Settat",
    nameAr: "الدار البيضاء-سطات",
    num: 6, color: "#808285",
    x: 35, y: 35,
    stats: { registeredVoters: 4100000, participation2021: 46.8, seats: 56 },
    connectedTo: ["RSK", "BMK", "MS"]
  },
  {
    id: "MS",
    name: "Marrakech-Safi",
    nameAr: "مراكش-أسفي",
    num: 7, color: "#D4702D",
    x: 35, y: 50,
    stats: { registeredVoters: 2600000, participation2021: 55.7, seats: 39 },
    connectedTo: ["CS", "BMK", "SM"]
  },
  {
    id: "DT",
    name: "Drâa-Tafilalet",
    nameAr: "درعة-تافيلالت",
    num: 8, color: "#869AC7",
    x: 70, y: 48,
    stats: { registeredVoters: 980000, participation2021: 61.2, seats: 15 },
    connectedTo: ["ORI", "FM", "BMK", "SM"]
  },
  {
    id: "SM",
    name: "Souss-Massa",
    nameAr: "سوس-ماسة",
    num: 9, color: "#8CC63F",
    x: 30, y: 65,
    stats: { registeredVoters: 1650000, participation2021: 53.2, seats: 21 },
    connectedTo: ["MS", "DT", "GON"]
  },
  {
    id: "GON",
    name: "Guelmim-Oued Noun",
    nameAr: "كلميم-واد نون",
    num: 10, color: "#BBA52F",
    x: 25, y: 78,
    stats: { registeredVoters: 308000, participation2021: 63.8, seats: 8 },
    connectedTo: ["SM", "LSH"]
  },
  {
    id: "LSH",
    name: "Laâyoune-Sakia El Hamra",
    nameAr: "العيون-الساقية الحمراء",
    num: 11, color: "#855F9E",
    x: 18, y: 88,
    stats: { registeredVoters: 220000, participation2021: 66.9, seats: 7 },
    connectedTo: ["GON", "DOD"]
  },
  {
    id: "DOD",
    name: "Dakhla-Oued Ed-Dahab",
    nameAr: "الداخلة-وادي الذهب",
    num: 12, color: "#00B7C6",
    x: 8, y: 96,
    stats: { registeredVoters: 105000, participation2021: 58.3, seats: 4 },
    connectedTo: ["LSH"]
  }
];
